import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  constructor() {}

  loadGtm(gtmId: string) {
    let gtmIdToApply = gtmId;
    if (gtmId === '1') {
      gtmIdToApply = 'MGHZ525';
    }

    if(!document.getElementById("gtmScript")) {
      const gtmScript = document.createElement('script');
      gtmScript.setAttribute("id", "gtmScript");
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-${gtmIdToApply}');
      `;
      document.head.appendChild(gtmScript);
    }
  }
}
